import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../i18n";

// Set to true once the final legal company data has been added to Impressum.jsx.
export const IMPRINT_PUBLISHED = false;

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[var(--border)] bg-white">
      <div className="mx-auto max-w-[1180px] px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col justify-between gap-8 sm:flex-row">
          <div className="max-w-sm">
            <div className="flex items-center gap-2"><span className="font-heading text-[20px] font-extrabold text-[var(--ink)]">Procur<span className="text-[var(--blue)]">mo</span></span></div>
            <p className="mt-4 text-sm leading-relaxed text-[var(--slate)]">{t.footer.tagline}</p>
            <span className="mt-4 inline-flex items-center gap-2 rounded-full border border-[var(--border)] bg-[var(--blue-soft)] px-3 py-1 text-xs font-semibold text-[var(--blue)]"><span className="h-1.5 w-1.5 rounded-full bg-[var(--blue)]" />{t.footer.prelaunch}</span>
          </div>
          <div className="flex gap-14">
            <div>
              <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">{t.footer.product}</div>
              <ul className="mt-3 space-y-2 text-sm text-[var(--slate)]">
                <li><a href="/#tenders" className="hover:text-[var(--ink)]">{t.nav.tenders}</a></li>
                <li><a href="/#partners" className="hover:text-[var(--ink)]">{t.nav.partners}</a></li>
                <li><a href="/#workspace" className="hover:text-[var(--ink)]">{t.nav.workspace}</a></li>
              </ul>
            </div>
            <div>
              <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">{t.footer.legal}</div>
              <ul className="mt-3 space-y-2 text-sm text-[var(--slate)]">
                <li>
                  {IMPRINT_PUBLISHED ? (
                    <Link to="/impressum" data-testid="footer-imprint-link" className="hover:text-[var(--ink)]">{t.footer.imprint}</Link>
                  ) : (
                    <span data-testid="footer-imprint-disabled" className="cursor-default select-none">{t.footer.imprint}</span>
                  )}
                </li>
                <li><Link to="/datenschutz" data-testid="footer-privacy-link" className="hover:text-[var(--ink)]">{t.footer.privacy}</Link></li>
                <li><a href="mailto:info@procurmo.com" data-testid="footer-contact-link" className="hover:text-[var(--ink)]">{t.footer.contact}</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-2 border-t border-[var(--border)] pt-6 text-xs text-slate-400 sm:flex-row sm:items-center">
          <span>{"\u00A9"} {year} Procurmo. {t.footer.rights}</span><a href="mailto:info@procurmo.com" className="hover:text-[var(--ink)]">info@procurmo.com</a>
        </div>
      </div>
    </footer>
  );
};
